import {
  FormContainerWithHeader,
  FormDateField,
  FormNumberInputAdornmentField,
  NewFormTextField,
  NewFromSelectField,
} from '../../../../../presentation';
import { POLICY_STATUS_OPTIONS, getFieldProps } from '@converge/data';

import { useTranslation } from 'react-i18next';

interface IProps {
  isReadonly?: boolean;
}
export const PolicyInfoFormSection = ({ isReadonly }: IProps) => {
  const { t } = useTranslation();

  return (
    <FormContainerWithHeader
      title={t(
        'entities.policy.detail.content.sections.overview.title',
        'Basic information'
      )}
    >
      <NewFormTextField
        {...getFieldProps(
          'referenceId',
          isReadonly,
          t(
            `policy.detail.content.sections.overview.info.fields.referenceId`,
            'Reference Id'
          )
        )}
      />
      <NewFromSelectField
        {...getFieldProps(
          'status',
          isReadonly,
          t(
            `policy.detail.content.sections.overview.info.fields.type`,
            'Status'
          )
        )}
        options={POLICY_STATUS_OPTIONS}
      />
      <FormDateField
        {...getFieldProps(
          'startDate',
          isReadonly,
          t(
            `policy.detail.content.sections.overview.info.fields.startDate`,
            'Start Date'
          )
        )}
      />
      <FormDateField
        {...getFieldProps(
          'endDate',
          isReadonly,
          t(
            `policy.detail.content.sections.overview.info.fields.endDate`,
            'End Date'
          )
        )}
      />
      <FormDateField
        {...getFieldProps(
          'transactionDate',
          isReadonly,
          t(
            `policy.detail.content.sections.overview.info.fields.transactionDate`,
            'Transaction Date'
          )
        )}
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'stampingFee',
          isReadonly,
          t(
            `policy.detail.content.sections.overview.info.fields.stampingFee`,
            'Stamping Fee'
          )
        )}
        thousandSeparator=","
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'policyFee',
          isReadonly,
          t(
            `policy.detail.content.sections.overview.info.fields.policyFee`,
            'Policy Fee'
          )
        )}
        thousandSeparator=","
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'stateTax',
          isReadonly,
          t(
            `policy.detail.content.sections.overview.info.fields.stateTax`,
            'State Tax'
          )
        )}
        thousandSeparator=","
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'stampingFee',
          isReadonly,
          t(
            `policy.detail.content.sections.overview.info.fields.stampingFee`,
            'Stamping Fee'
          )
        )}
        thousandSeparator=","
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'boundPremium',
          isReadonly,
          t(
            `policy.detail.content.sections.overview.info.fields.boundPremium`,
            'Bound Premium'
          )
        )}
        thousandSeparator=","
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'grossPremium',
          isReadonly,
          t(
            `policy.detail.content.sections.overview.info.fields.grossPremium`,
            'Gross Premium'
          )
        )}
        thousandSeparator=","
      />
      <FormNumberInputAdornmentField
        adornmentText={'$'}
        {...getFieldProps(
          'netPremium',
          isReadonly,
          t(
            `policy.detail.content.sections.overview.info.fields.netPremium`,
            'Net Premium'
          )
        )}
        thousandSeparator=","
      />
      <NewFormTextField
        {...getFieldProps(
          'insuredName',
          isReadonly,
          t(
            `policy.detail.content.sections.overview.info.fields.insuredName`,
            'Insured Name'
          )
        )}
      />
    </FormContainerWithHeader>
  );
};
